import { SupportedChainId } from '@/constants/chain';

import { Avatar, AvatarProps } from '../Avatar';
import { chainAvatarSvg } from './chainAvatarLogos';

export type ChainAvatarProps = Omit<AvatarProps, 'radius'> & {
  /**
   * ID of the chain to display the avatar for.
   */
  chainId?: number;
};

export const chainAvatarRadius = '32%';

export const ChainAvatar = (props: ChainAvatarProps) => {
  const { chainId, size = 24, ...otherProps } = props;

  const src = chainId != null ? chainAvatarSvg[chainId as SupportedChainId] : undefined;

  return (
    <Avatar
      src={src}
      fallbackSrc="/images/chains/none.svg"
      radius={chainAvatarRadius}
      size={size}
      {...otherProps}
    />
  );
};
